import React from 'react';

export default class AssetRow extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this)
  }

  openModal() {
    const {RowData, setDataEdit} = this.props;
    setDataEdit(RowData)
  }

  renderFieldContent(content){
    return (content && content !== "") ? content : "-"
  }

  render() {
    const {RowData} = this.props
    return (
      <tr>
        <td>
          {RowData.Name}
        </td>
        <td>
          {RowData.Type}
        </td>
        <td>
          {this.renderFieldContent(RowData.Tag)}   
        </td>
        <td>
          {RowData.SerialNumber}   
        </td>
        <td>
          {RowData.PurchasedDate}   
        </td>
        <td>
          {RowData.Status}   
        </td>
        <td className="text-center">
          <button
            className="btn btn-4r btn-sm btn-primary"
            onClick={()=>this.props.history.push("/admin/master-asset-details-"+RowData.Alias+"/")}
          >
            <i className="icon-pencil"></i>
          </button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/component/AssetRow.js